type FlagProps = React.SVGProps<SVGSVGElement> & {
  /** If provided, the flag is announced to screen readers; otherwise it’s decorative */
  title?: string;
};


export const Norway = ({ title, ...props }: FlagProps) => {
  return (
    <svg
      width="24"
      height="16"
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Norway flag"
      {...props}
    >
      <g clipPath="url(#clip0_566_4347)">
    <mask id="mask0_566_4347" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="16">
      <path d="M21.7143 0H2.28571C1.02335 0 0 0.955126 0 2.13333V13.8667C0 15.0449 1.02335 16 2.28571 16H21.7143C22.9767 16 24 15.0449 24 13.8667V2.13333C24 0.955126 22.9767 0 21.7143 0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_566_4347)">
      <rect x="0" y="0" width="24" height="16" rx="2" ry="2" fill="#ac2431" />
      <path fill="#fff" d="M24 8H14V16H10V8H0V6H10V0H14V6H24V8Z" />
      <path fill="#061a57" d="M24 9H13V16H11V9H0V7H11V0H13V7H24V9Z" />
      <path d="M21.7143 0.5H2.28571C1.24029 0.5 0.5 1.231 0.5 2.13333V13.8667C0.5 14.769 1.24029 15.5 2.28571 15.5H21.7143C22.7597 15.5 23.5 14.769 23.5 13.8667V2.13333C23.5 1.231 22.7597 0.5 21.7143 0.5Z" stroke="black" strokeOpacity="0.1" />
    </g>
  </g>
  <defs>
    <clipPath id="clip0_566_4347">
      <rect width="24" height="16" fill="white" />
    </clipPath>
  </defs>
</svg>
  );
};
